import { getFieldCopy, type FieldCopy, type LocaleKey } from "@/i18n";
import { TelephoneField, type TelephoneFieldProps } from "../telephone-field";
import type { FieldPath, FieldValues } from "react-hook-form";
import { type CommonCopy } from "@/i18n";

export type CdcBusinessTelephoneFieldCopy = FieldCopy & {
  label: string;
  dialCodeLabel: string;
  dialCodePlaceholder: string;
  placeholder?: string;
  errors?: Record<string, string>;
};

export type CdcBusinessTelephoneFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  TelephoneFieldProps<TFieldValues, TName>,
  | "fieldKey"
  | "options"
  | "label"
  | "placeholder"
  | "dialCodesLabel"
  | "dialCodesPlaceholder"
  | "description"
> & {
  locale: LocaleKey;
  show?: boolean;
};

export function CdcBusinessTelephoneField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  locale,
  show = true,
  ...rest
}: Readonly<CdcBusinessTelephoneFieldProps<TFieldValues, TName>>) {
  const { label, placeholder, dialCodeLabel, dialCodePlaceholder } =
    getFieldCopy(
      locale,
      "businessTelephone",
    ) as unknown as CdcBusinessTelephoneFieldCopy;
  const { errors: requiredLabel } = getFieldCopy(
    locale,
    "common",
  ) as unknown as CommonCopy;

  return show ? (
    <TelephoneField
      {...rest}
      label={label}
      placeholder={placeholder}
      dialCodesLabel={dialCodeLabel}
      dialCodesPlaceholder={dialCodePlaceholder}
      requiredLabel={requiredLabel.required}
    />
  ) : null;
}
